import {TaskLinkedContact, TaskLinkedContactField, TaskStatus} from '../../../../../services/cellcast.v2.types'

export const STATUS_META: Record<
  TaskStatus,
  {
    icon: string
    className: string
    label: string
  }
> = {
  pending: {
    icon: 'bi-check-circle',
    className: '',
    label: 'Pending',
  },
  completed: {
    icon: 'bi-check-circle-fill',
    className: 'text-success',
    label: 'Completed',
  },
}

export const formatTaskInitials = (value?: string | null) => {
  if (!value) return 'NA'
  const words = value.trim().split(/\s+/).slice(0, 2)
  const initials = words.map((word) => word.charAt(0)).join('')
  return initials.toUpperCase() || 'NA'
}

export const resolveContactLabel = (contact?: TaskLinkedContact | null) => {
  if (!contact) {
    return 'Contact'
  }

  if (
    'fullName' in contact &&
    typeof contact.fullName === 'string' &&
    contact.fullName.trim().length > 0
  ) {
    return contact.fullName.trim()
  }

  const fields = contact.fields ?? []
  const findFieldValue = (key: string) =>
    fields.find((field: TaskLinkedContactField) => field.name === key)?.value

  return (
    findFieldValue('Full Name') ||
    findFieldValue('First Name') ||
    findFieldValue('Last Name') ||
    contact.number ||
    contact.id ||
    'Contact'
  )
}

export const formatDateTime = (value?: string | null): string => {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

